import { render, staticRenderFns } from "./modulPage.vue?vue&type=template&id=16c77426&scoped=true"
import script from "./modulPage.vue?vue&type=script&lang=js"
export * from "./modulPage.vue?vue&type=script&lang=js"
import style0 from "./modulPage.vue?vue&type=style&index=0&id=16c77426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c77426",
  null
  
)

export default component.exports